module.exports = __webpack_public_path__ + "static/img/14000133.7273937e.png";